import React from 'react'
import JointReplacementsurgery from "../images/Joint Replacement surgery.jpg";
import spine_back_pain_treatment from "../images/spine-back-pain-treatment.jpg";
import arthritistreetmnet from "../images/arthritis treetmnet.jpg";

function Clinic() {
    return (
        <div>
            <div className="album py-0">
                <div className="container">
                    <div className="row ">
                        <div className="col-md-5 me-5">
                            <h6>Orthopedic Departments
                            </h6>
                            <h2><b>Specialized Divisions of Orthopedic Care</b></h2>

                        </div>
                        <div className="col-md-6" >
                            <h6 style={{ color: "#ffffff" }}>Our orthopedic care combines advanced medical expertise, precise diagnosis, and personalized treatment for bone, joint, and spine conditions. </h6>


<a href='Doctor'>
                            <button className='buttonnew'> Doctor Appointment</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
<br/>
<br/>
            <div className="album py-1">
                <div className="container">
                    <div className="row ">
                        <div className="col-md-4 mt-3">
                            <div className="card">
                                
                                <img src={JointReplacementsurgery} className="card-img-top" alt="Joint Replacement surgery" />
                                <div className="card-body">
                                    <h5 style={{color:"#057bb5"}} className="card-title">Joint Replacement surgery</h5>
                                    <p style={{color:"#63686b"}}  className="card-text">Relieves joint pain and restores mobility for better movement and quality of life.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card">
                                <img src={spine_back_pain_treatment} className="card-img-top" alt="spine_back_pain_treatment Replacement surgery" />
                                <div className="card-body">
                                    <h5 style={{color:"#057bb5"}} className="card-title">Spine back pain treatment</h5>
                                    <p style={{color:"#63686b"}}  className="card-text">Expert care to relieve back pain, improve spinal health, and restore comfortable movement.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card">
                                <img src={arthritistreetmnet} className="card-img-top" alt="arthritis treetmnet" />
                                <div className="card-body">
                                    <h5 style={{color:"#057bb5"}} className="card-title">Arthritis treetmnet</h5>
                                    <p style={{color:"#63686b"}}  className="card-text">Personalized care to reduce joint pain, stiffness, and inflammation while improving mobility and quality of life.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Clinic